(function ($, Drupal, drupalSettings) {
    "use strict";
    /**
     * Attaches the JS countdown behavior
     */
    Drupal.behaviors.jsCountdownTimer = {
        attach: function (context) {
            var note = $('#jquery-countdown-timer'),
                ts = new Date(drupalSettings.countdown.unixtimestamp * 1000);

            const cdTimerEl = once('jquery-countdown-timer', '#jquery-countdown-timer', context);
            if (typeof cdTimerEl[0] !== 'undefined') {
                $(cdTimerEl[0]).countdownBlock({
                    timestamp: ts,
                    font_size: drupalSettings.countdown.fontsize,
                    callback: function (days, hours, minutes, seconds) {
                        var dateStrings = new Array();
                        days = days < 10 ? '0' + days : days;
                        hours = hours < 10 ? '0' + hours : hours;
                        minutes = minutes < 10 ? '0' + minutes : minutes;
                        seconds = seconds < 10 ? '0' + seconds : seconds;
                        var resultTimer = '';
                        resultTimer += '<div class="s-cdTimer__item"><span class="s-cdTimer__num">' + days + '</span><span class="s-cdTimer__name">' + Drupal.formatPlural(days, 'Day', 'Days') + '</span></div>';
                        resultTimer += '<div class="s-cdTimer__item"><span class="s-cdTimer__num">' + hours + '</span><span class="s-cdTimer__name">' + Drupal.formatPlural(hours, 'Hour', 'Hours') + '</span></div>';
                        resultTimer += '<div class="s-cdTimer__item"><span class="s-cdTimer__num">' + minutes + '</span><span class="s-cdTimer__name">' + Drupal.formatPlural(minutes, 'Minute', 'Minutes') + '</span></div>';
                        resultTimer += '<div class="s-cdTimer__item"><span class="s-cdTimer__num">' + seconds + '</span><span class="s-cdTimer__name">' + Drupal.formatPlural(seconds, 'Second', 'Seconds') + '</span></div>';
                        note.addClass('s-cdTimer').html(resultTimer);
                    }
                });
            }
        }
    };
})(jQuery, Drupal, drupalSettings);
